export default __webpack_public_path__ + "static/card-dinersclub-ff63cd5b5b0954ea5edfa7a0e1751cbb.svg";